import { render, staticRenderFns } from "./batchModifyPrice.vue?vue&type=template&id=1fd94363&scoped=true&"
import script from "./batchModifyPrice.vue?vue&type=script&lang=js&"
export * from "./batchModifyPrice.vue?vue&type=script&lang=js&"
import style0 from "./batchModifyPrice.vue?vue&type=style&index=0&id=1fd94363&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd94363",
  null
  
)

export default component.exports